import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import DialogModal from '../../common/DialogModal';
import Input from 'material-ui/Input';
import Button from 'material-ui/Button';
import Trash from '../../Icons/Trash';
import Loader from '../../Parts/Loader';
import * as errMessages from '../../../constants/ErrorMessages'
import * as messages from '../../../constants/Messages'
import NotificationBar from '../../Parts/NotificationBar.jsx'

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  emptyContainer: {
    padding: '50px',
    position: 'relative',
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    boxSizing: 'border-box',
    width: '100%',
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  row: {
    padding: '15px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    borderBottom: '1px solid #D8DBDF',
    boxSizing: 'border-box',
  },

  input: {
    boxSizing: 'border-box',
    height: '38px',
    fontSize: '15px',
  },

  button: {
    border: '1px solid #D8DBDF',
    marginLeft: '10px',
    fontSize: '15px',
    height: '38px',
    boxSizing: 'border-box',
    minWidth: 'unset',
    padding: 0,
  }
});

class EditFilterDialog extends React.Component {
  state = {
    filters: {},
    errors: {},
    showNotification: false,
    message: '',
    messageType: 'success',
  }

  componentWillMount() {
    this.setFilters(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.patchingFilterId !== null && nextProps.patchingFilterId === null)
      || (this.props.deletingFilterId !== null && nextProps.deletingFilterId === null)
      || (this.props.isLoadingFilter && nextProps.isLoadingFilter === false)) {
      this.setFilters(nextProps);
    }

    if ((this.props.patchingFilterId !== null && nextProps.patchingFilterId === null)
      || (this.props.deletingFilterId !== null && nextProps.deletingFilterId === null)) {
      if (!nextProps.errorMessage) {
        this.displayNotification(messages.SAVE_SUCCESS, "green");
      }
    }
  }

  setFilters = (props) => {
    let filters = {}

    props.filters.forEach(filter => {
      filters[filter.id] = { id: filter.id, name: filter.name };
    })

    this.setState({
      filters: filters,
    });
  }

  handleChange = rowId => (e) => {
    let filters = { ...this.state.filters };
    let errors = { ...this.state.errors };

    filters[rowId].name = e.target.value;

    if (!e.target.value) {
      errors[rowId] = errMessages.ERR_EMPTY;
    } else {
      delete errors[rowId];
    }

    this.setState({
      filters: filters,
      errors: errors,
    })
  }

  handleFocus = rowId => () => {
    this.textOnFocus = this.state.filters[rowId].name;
  }

  handleBlur = rowId => () => {
    if (this.state.filters[rowId].name !== this.textOnFocus && !this.state.errors.hasOwnProperty(rowId)) {
      this.props.patchExecutiveListFiltersById(rowId, { name: this.state.filters[rowId].name })
    }
  }

  handleShow = rowId => () => {
    this.props.handleFilterSelected(rowId.toString());
    this.props.toggleDialog();
  }

  handleDelete = rowId => () => {
    let filters = { ...this.state.filters };
    delete filters[rowId];
    this.setState({
      filters: filters,
    })

    this.props.deleteExecutiveListFiltersById(rowId);
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 10000, top: 10, left: 'calc(50% - 100px)' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false })
          }}
          autoClose={true}
          animation="fade"
        >
        </NotificationBar>
      </div>
    )
  }

  renderRow = (item) => {
    const { classes } = this.props;

    return (
      <div className={classes.row} key={item.id}>
        <Input
          key={item.id}
          value={item.name}
          disableUnderline={true}
          classes={{
            input: classes.input
          }}
          style={{ flex: 1 }}
          placeholder="名前を入力"
          onChange={this.handleChange(item.id)}
          onFocus={this.handleFocus(item.id)}
          onBlur={this.handleBlur(item.id)}
          error={this.state.errors.hasOwnProperty(item.id)}
        />

        <Button className={classes.button} style={{ width: '70px' }} onClick={this.handleShow(item.id)}>
          表示
        </Button>

        <Button className={classes.button} style={{ width: '38px' }} onClick={this.handleDelete(item.id)}>
          <Trash height={16} width={16} color="#181819" />
        </Button>
      </div>
    )
  }

  render() {
    const { classes, toggleDialog, isOpen } = this.props;
    const { filters } = this.state;

    let notification = this.renderNotification();

    return (
      <DialogModal
        title="絞り込み条件を編集"
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        {(() => {
          if (this.props.isLoadingFilter) {
            return (
              <div className={classes.emptyContainer}>
                <Loader type="color" size="large" />
              </div>
            )
          } else if (!this.props.isLoadingFilter && this.props.filters.length === 0) {
            return (
              <div className={classes.emptyContainer}>
                <Typography variant="body2" style={{ color: '#71737B' }}>
                  保存した絞り込み条件はありません。
                </Typography>
              </div>
            )
          } else {
            return (
              <div className={classes.container}>
                {Object.values(filters).map(filter => this.renderRow(filter))}
              </div>
            )
          }
        })()}
        {notification}
      </DialogModal>
    );
  }
}

EditFilterDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isPostingFilter: PropTypes.bool,
  filters: PropTypes.array.isRequired,
  patchExecutiveListFiltersById: PropTypes.func.isRequired,
  deleteExecutiveListFiltersById: PropTypes.func.isRequired,
  patchingFilterId: PropTypes.number,
  deletingFilterId: PropTypes.number,
  isLoadingFilter: PropTypes.bool,
  handleFilterSelected: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

export default withStyles(styles)(EditFilterDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/EditFilterDialog.jsx